export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            了解51吃瓜黑料的初心与使命
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10">
          <div className="flex flex-col md:flex-row gap-8 items-start">
            <div className="flex-shrink-0">
              <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-2xl bg-primary-500">
                <i className="ri-fire-fill text-background-50 text-3xl md:text-4xl"></i>
              </div>
            </div>
            <div className="flex-1">
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
                51吃瓜黑料 — 你的吃瓜第一站
              </h3>
              <div className="space-y-3 text-foreground-600 text-sm md:text-base leading-relaxed">
                <p>
                  51吃瓜黑料成立于对真相的执着追求，是一个集吃瓜爆料、黑料曝光、今日黑料与网曝门事件于一体的综合性爆料平台。
                  我们致力于为每一位吃瓜群众提供最新、最全、最真实的热点内幕资讯。
                </p>
                <p>
                  平台内容覆盖娱乐圈八卦、网红圈翻车、社会热点解读、电竞圈故事等多个领域，通过多渠道信源交叉验证和严格的内容审核机制，
                  确保每一条爆料都有据可查。我们坚持「不造谣、不传谣、不信谣」的原则，为读者呈现事件的多维度视角。
                </p>
                <p>
                  实时更新是我们的核心承诺。无论你何时打开51吃瓜黑料，都能看到最新的独家猛料和持续跟进的深度报道。
                  我们相信，每一个"瓜"背后都值得被认真对待，每一个读者都应该拥有获取真实信息的权利。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}